import { useClientSpecificCustomTextDeleteEditActionsOnAvatar } from '@hooks/clientSpecificUtils';
import ConfirmDeleteAvatarModalView from './ConfirmDeleteAvatarModalView';
import { IConfirmDeleteAvatarModal } from './interfaces';
import { useStyles } from './styles';

const ConfirmDeleteAvatarModal = ({
  handleConfirm,
  handleCancel,
  open,
  avatarToDelete,
  isProcessing = false,
}: IConfirmDeleteAvatarModal) => {
  const { customDeleteAvatarTitle, customDeleteAvatarText } =
    useClientSpecificCustomTextDeleteEditActionsOnAvatar(avatarToDelete);
  const classes = useStyles();

  return (
    <ConfirmDeleteAvatarModalView
      handleConfirm={handleConfirm}
      isConformProcessing={isProcessing}
      handleCancel={handleCancel}
      open={open}
      deleteTitle={
        customDeleteAvatarTitle
          ? customDeleteAvatarTitle
          : 'deleteAvatarModal.title'
      }
      deleteText={
        customDeleteAvatarText
          ? customDeleteAvatarText
          : 'deleteAvatarModal.text'
      }
      sx={classes}
    />
  );
};

export default ConfirmDeleteAvatarModal;
